import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
@Component({
    selector: 'app-developer-application-menu',
    templateUrl: './developer-application-menu.component.html',
    styleUrls: ['./developer-application-menu.component.scss'],
    standalone: true,
    imports: [MatIconModule, MatButtonModule]
})
export class DeveloperApplicationMenuComponent implements OnInit {

  public applicationName: any;
  constructor(public router: Router, private route: ActivatedRoute) {
    this.applicationName = this.route.snapshot.paramMap.get('applicationName');
  }

  ngOnInit(): void { }

  viewApplicationdetails() {
    this.router.navigate([
      'secure/developer/application-detail',
      { Application_Name: this.applicationName },
    ]);
  }
  
  viewApplicationUsers() {
    this.router.navigate([
      'secure/developer/users',
      { Application_Name: this.applicationName },
    ]);
  }

  viewApplicationGroups() {
    this.router.navigate([
      'secure/developer/groups',
      { Application_Name: this.applicationName },
    ]);
  }


  viewApplicationAdmins() {
    this.router.navigate([
      'secure/developer/admins',
      { Application_Name: this.applicationName },
    ]);
  }


}


